import { z } from 'zod';
/** zod mirrors of protocol/schemas/api/*.json — REST request/response contracts (§3.7). */
export const API_ERROR_CODES = [
    'bad_request',
    'bad_version',
    'bad_token',
    'code_invalid',
    'code_expired',
    'code_revoked',
    'code_exhausted',
    'not_admin',
    'room_full',
    'no_such_room',
    'no_such_participant',
    'controller_conflict',
    'room_ended',
    'payload_too_large',
    'rate_limited',
    'host_offline',
    'internal',
];
export const ApiError = z
    .object({
    error: z
        .object({
        code: z.enum(API_ERROR_CODES),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    })
        .strict(),
})
    .strict();
export const MetaResponse = z
    .object({
    apiVersion: z.string(),
    protocolVersion: z.number().int().min(1),
    minHostProtocol: z.number().int().min(1),
    minClientProtocol: z.number().int().min(1),
})
    .strict();
export const JoinRequest = z
    .object({
    code: z.string().min(1).max(32),
    name: z.string().min(1).max(24),
})
    .strict();
export const JoinResponse = z
    .object({
    roomId: z.string().uuid(),
    identity: z.string().regex(/^u-[A-Za-z0-9_-]+$/),
    role: z.enum(['viewer', 'controller']),
    admin: z.boolean(),
    wsUrl: z.string().url(),
    lkToken: z.string(),
    gonzoToken: z.string(),
})
    .strict();
export const HostSessionResponse = z
    .object({
    roomId: z.string().uuid(),
    wsUrl: z.string().url(),
    lkToken: z.string(),
    gonzoToken: z.string(),
})
    .strict();
export const ControlGrantRequest = z
    .object({
    identity: z.string().min(1),
    ttlSec: z.number().int().min(1).max(3600).optional(),
})
    .strict();
export const ControlAcceptRequest = z
    .object({ epoch: z.number().int().min(0) })
    .strict();
export const CreateCodeRequest = z
    .object({
    role: z.enum(['viewer', 'controller']).optional(),
    ttlSec: z.number().int().min(900).max(86400).optional(),
    maxUses: z.number().int().min(1).optional(),
})
    .strict();
export const CreateCodeResponse = z
    .object({
    codeId: z.string().uuid(),
    code: z.string(),
    role: z.enum(['viewer', 'controller']),
    expiresAt: z.string().datetime(),
})
    .strict();
export const ChatPostRequest = z
    .object({
    id: z.string().uuid(),
    body: z.string().min(1).max(2000),
})
    .strict();
export const TelemetryRequest = z
    .object({
    samples: z
        .array(z
        .object({
        ts: z.number().int(),
        rtt: z.number().min(0),
        jitter: z.number().min(0),
        fps: z.number().min(0),
        freezeCount: z.number().int().min(0).optional(),
        candidatePairType: z.string().optional(),
        bytesReceived: z.number().int().min(0).optional(),
    })
        .strict())
        .min(1)
        .max(100),
})
    .strict();
//# sourceMappingURL=api.js.map